import './App.css';
import headerImage from "./header_image.jpg";
import React, {useState, useRef} from "react";
import axios from 'axios';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';

function App() {
  const apiToken = "4ye4ybtqemuqkwi7k7jeguo1i0ofkdkqe6i45qrbzpk8p26a";
  const [closedRegistration, setClosedRegistration] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [formFinished, setFormFinished]  = useState(false);
  const [personName, setPersonName] = useState("");
  const [personNameErrorMode, setPersonNameErrorMode] = useState(0);
  const [personEmail, setPersonEmail] = useState("");
  const [personEmailErrorMode, setPersonEmailErrorMode] = useState(0);
  const [personTelephone, setPersonTelephone] = useState("");
  const [personTelephoneErrorMode, setPersonTelephoneErrorMode] = useState(0);
  const [personType, setPersonType] = useState(0);
  const [personOrigin, setPersonOrigin] = useState("");
  const [personDiet, setPersonDiet] = useState(0);
  const [rulesAccepted, setRulesAccepted] = useState(false);
  const [rodoAccepted, setRodoAccepted] = useState(false);
  const [reservationNumber, setReservationNumber] = useState(false);
  const mainNameForm = useRef(null);
  const mainEmailForm = useRef(null);
  const mainTelephoneForm = useRef(null);

  const LoadingSpinner = () => {
    return (
        <CircleSpinnerOverlay
            loading={isLoading}
            color="#003A39"
            overlayColor="#00003A39"
        />
    );
  }

  const handleClickReserve = () => {
    if (validateForm()) {
      const jsonData = JSON.stringify(generateJSONForm(), null, 2);
      setIsLoading(true);
      axios.post('https://rdpw.pw.edu.pl/api/gmn/addToConference.php', jsonData)
        .then((response) => {
          setIsLoading(false);
          let returnInfo = response.data;
          if (Number.isInteger(returnInfo)) {
            setReservationNumber(returnInfo);
            setFormFinished(true);
          } else {
            alert(returnInfo);
          }
        }, (error) => {
          setIsLoading(false);
        });
    }
  };

  const validateForm = () => {
    var status = true;
    var scrolled = false;
    const validRegexPW = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@pw.edu.pl$/;
    const personNameMode = personName !== "" ? 0 : 1;
    setPersonNameErrorMode(personNameMode);
    status = status && personNameMode === 0;
    if (!status && !scrolled) {
      mainNameForm.current.scrollIntoView()
      scrolled = true;
    }
    const personEmailMode = personEmail === "" ? 1 : personEmail.match(validRegexPW) ? 0 : 2;
    setPersonEmailErrorMode(personEmailMode);
    status = status && personEmailMode === 0;
    if (!status && !scrolled) {
      mainEmailForm.current.scrollIntoView()
      scrolled = true;
    }
    const personTelephoneMode = personTelephone === "" ? 1 : personTelephone.match(/^[0-9\+]{9,14}$/) ? 0 : 2;
    setPersonTelephoneErrorMode(personTelephoneMode);
    status = status && personTelephoneMode === 0;
    if (!status && !scrolled) {
      mainTelephoneForm.current.scrollIntoView()
    }
    return status;
  };

  const generateJSONForm = () => {
    return { basic_data: { token: apiToken, name: personName.trim(), email: personEmail, telephone: personTelephone, type: personType, origin: personOrigin.trim(), diet: personDiet } };
  };

  const ticketFormGeneration = () => {
    return (
        <x>
          <div className="formSection">
            <div ref={mainTelephoneForm}></div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Imię i nazwisko*</div>
                <div align="left" className="formEN">Firstname & lastname*</div>
              </div>
              <div className={personNameErrorMode !== 0 ? "group error" : "group"}>
                <input type="text" value={personName} onChange={e => setPersonName(e.target.value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,""))}/>
              </div>
              {personNameErrorMode === 1 ? <div className="group errorLabel">Wprowadź imię i nazwisko</div> : ""}
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">E-mail w domenie PW*</div>
                <div align="left" className="formEN">E-mail in PW domain*</div>
              </div>
              <div className={personEmailErrorMode !== 0 ? "group error" : "group"}>
                <input type="text" value={personEmail} onChange={e => setPersonEmail(e.target.value.trim())}/>
              </div>
              {personEmailErrorMode === 1 ? <div className="group errorLabel">Wprowadź e-mail</div> : personEmailErrorMode === 2 ? <div className="group errorLabel">Niepoprawny format e-maila</div> : ""}
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Numer telefonu*</div>
                <div align="left" className="formEN">Telephone number*</div>
              </div>
              <div className={personTelephoneErrorMode !== 0 ? "group error" : "group"}>
                <input type="text" value={personTelephone} onChange={e => setPersonTelephone(e.target.value.trim().replace( /\s|-/g, "" ))}/>
              </div>
              {personTelephoneErrorMode === 1 ? <div className="group errorLabel">Wprowadź numer telefonu</div> : personTelephoneErrorMode === 2 ? <div className="group errorLabel">Niepoprawny format telefonu</div> : ""}
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Rodzaj biletu</div>
                <div align="left" className="formEN">Type of ticket</div>
              </div>
              <div className="group">
                <label className="container"><div align="left" className="formPL">Student PW</div><div align="left" className="formEN">WUT Student</div><input type="radio" name="type" value="0" className="checkbox" defaultChecked onChange={e => setPersonType(parseInt(e.target.value))}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Doktorant PW</div><div align="left" className="formEN">WUT PhD Candidate </div><input type="radio" name="type" value="1" className="checkbox" onChange={e => setPersonType(parseInt(e.target.value))}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Asystent/Adiunkt PW</div><div align="left" className="formEN">WUT Teaching Assistant/Assistant Professor</div><input type="radio" name="type" value="2" className="checkbox" onChange={e => setPersonType(parseInt(e.target.value))}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Pracownik naukowy PW</div><div align="left" className="formEN">WUT Research Worker</div><input type="radio" name="type" value="4" className="checkbox" onChange={e => setPersonType(parseInt(e.target.value))}/><span
                    className="radio"></span></label>
              </div>
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Koło Naukowe/Szkoła Doktorska/Wydział</div>
                <div align="left" className="formEN">Science Club/Doctoral School/Faculty</div>
              </div>
              <div className="group">
                <input type="text" value={personOrigin} onChange={e => setPersonOrigin(e.target.value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,""))} />
              </div>
            </div>
            <div align="left">
              <div className="groupWithoutMargin">
                <div align="left" className="formPL">Dieta</div>
                <div align="left" className="formEN">Diet</div>
              </div>
              <div className="group">
                <label className="container"><div align="left" className="formPL">Klasyczna</div><div align="left" className="formEN">Classic</div><input type="radio" name="food" value="0" className="checkbox" defaultChecked onChange={e => setPersonDiet(parseInt(e.target.value))}/><span
                    className="radio"></span></label>
                <label className="container"><div align="left" className="formPL">Wegetariańska</div><div align="left" className="formEN">Vegetarian</div><input type="radio" name="food" value="1" className="checkbox" onChange={e => setPersonDiet(parseInt(e.target.value))}/><span
                    className="radio"></span></label>
              </div>
            </div>
          </div>
          <hr className="rounded"/>
        </x>
    );
  }

  const termsFormGeneration = () => {
    return (
        <x>
          <div className="formSection">
            <div align="left">
              <label className="container"><div align="left" className="formPL">Akceptuję regulamin Wydarzenia oraz Rejestracji na Kongres*</div><div align="left" className="formEN">Accepting the terms and conditions of the Event and Congress Registration*</div><input type="checkbox" value={rulesAccepted} onChange={e => setRulesAccepted(e.target.checked)} className="checkbox"/><span
                  className="checkmark"></span></label>   <a className="appLink" href="https://rdpw.pw.edu.pl/Regulamin_Kongresu.pdf" target="_blank" rel="noopener noreferrer">Link</a><br/>
              <label className="container"><div align="left" className="formPL">Wyrażam zgodę na przetwarzanie moich danych osobowych przez Radę Doktorantów Politechniki Warszawskiej w celu przeprowadzenia procesu rezerwacji, zakupu i weryfikacji biletów na Galę Młodych Naukowców.  Administratorem danych osobowych jest Rada Doktorantów Politechniki Warszawskiej (bmn.rdpw@pw.edu.pl)*</div><div align="left" className="formEN">I consent to the processing of my personal data by the Council of Doctoral Students of Warsaw University of Technology for the purpose of booking, purchasing and verifying tickets for the Young Scientists Gala.  The administrator of the personal data is the Council of Doctoral Students of Warsaw University of Technology (bmn.rdpw@pw.edu.pl)*</div><input type="checkbox" value={rodoAccepted} onChange={e => setRodoAccepted(e.target.checked)} className="checkbox"/><span className="checkmark"></span></label>
            </div>
          </div>
          <hr className="rounded"/>
        </x>
    );
  }

  const requiredFieldsGeneration = () => {
    return (
        <x>
          <div>
            <div className="formPL">*pola obowiązkowe</div><div className="formEN">*required fields</div>
          </div>
        </x>
    );
  }

  const mainFormGeneration = () => {
    return (
      <x>
          <content>
            {isLoading ? <LoadingSpinner /> : ""}
            <hr className="rounded"/>
            {ticketFormGeneration()}
            {termsFormGeneration()}
            {requiredFieldsGeneration()}
            <div><input type="button" className="button" value="Rezerwuję!" disabled={isLoading || !rulesAccepted || !rodoAccepted} onClick={handleClickReserve}/></div>
            <br/>
          </content>
      </x>
    );
  }

  const finishFormGeneration = () => {
    return (
          <content>
            <hr className="rounded"/>
            <div className="formSection">
              <div>
                <div align="left" className="formPLBold">Podsumowanie rezerwacji nr {reservationNumber}</div>
                <div align="left" className="formENBold">Reservation number {reservationNumber} confirmation</div>
              </div><br/>
              <div>
                <div align="left" className="formPL">Dziękujemy za rezerwację biletu na Kongres podczas Gali Młodych Naukowców PW w dniu 21 stycznia 2023r. o godz. 10:00 w Gmachu Głównym Politechniki Warszawskiej</div>
                <div align="left" className="formEN">Thank you for booking your ticket to attend the Congress at the WUT Young Scientists Gala on January 21, 2023. at 10:00 am at the Main Building of the Warsaw University of Technology</div>
              </div><br/>
              <div>
                <div align="left" className="formPL">Informacja z biletem konferencyjnym została wysłana automatycznie na podany przez Ciebie adres e-mailowy. Jeśli nie dostałeś/-aś biletu na adres e-mail podany w rezerwacji sprawdź folder SPAM. Jeśli w ciągu doby nie dostaniesz biletu napisz do nas na adres e-mail: <a href='mailto:bmn.rdpw@pw.edu.pl'><i>bmn.rdpw@pw.edu.pl</i></a></div>
                <div align="left" className="formEN">Information with conference ticket was sent automatically to provided e-mail by you. If you did not receive a ticket to the email address provided in the booking, check your SPAM folder. If you do not receive a ticket within 24 hours, write to us at the email address: <a href='mailto:bmn.rdpw@pw.edu.pl'><i>bmn.rdpw@pw.edu.pl</i></a></div>
              </div>
            </div>
            <hr className="rounded"/>
          </content>
    );
  }

  const closedRegistrationForm = () => {
    return (
        <content>
          <hr className="rounded"/>
          <div className="closedForm">
            <div>
              <div align="center" className="formPLBold">Rezerwacja zamknięta</div>
              <div align="center" className="formENBold">Closed reservation</div>
            </div><br/>
            <div>
              <div align="center" className="formPL">Dziękujęmy za zainteresowanie 1. Galą Młodych Naukowców. Niestety rezerwacja została już zamknięta. Jeśli jednak chcesz się spotkać z nami na Kongresie zachęcamy do kontaktu emailowego w celu omówienia ewentualnego zakupu biletów: bmn.rdpw@pw.edu.pl</div>
              <div align="center" className="formEN">Thank you for your interest in the 1st Young Scientists Gala. Unfortunately, reservations have already been closed. However, if you would like to meet us at the Congress, we encourage you to contact us by email to discuss the possible purchase of tickets: bmn.rdpw@pw.edu.pl</div>
            </div>
          </div>
          <hr className="rounded"/>
        </content>
    );
  }

  return (
      <x>
        <body>
          <header>
            <img className="imageHeader" src={headerImage} />
          </header>
          <div ref={mainNameForm}></div><br/>
          <div style={{ "height": "50px" }}/>
          <div ref={mainEmailForm}></div>
          <h1 className="groupWithoutMargin">
            <div align="center" className="formPL">Rezerwacja biletu na Kongres podczas Gali Młodych Naukowców</div>
            <div align="center" className="formEN" style={{ "margin-bottom": "-20px" }}>Booking a ticket to the Congress at the Young Scientists Gala</div>
          </h1>
          {closedRegistration ? closedRegistrationForm() : "" }
          {!closedRegistration ? formFinished ? finishFormGeneration() : mainFormGeneration() : "" }
          <footer>
            <p className="footerTextLarge">KONTAKT</p>
            <p className="footerTextSmall">Gala Młodych Naukowców Politechniki Warszawskiej<br/>Rada Doktorantów Politechniki Warszawskiej</p>
            <p className="footerTextSmall">bmn.rdpw@pw.edu.pl</p>
            <hr className="footerRoundedSeparator"/>
            <p className="footerTextSmall">Developed by Mikołaj Płachta</p>
          </footer>
        </body>
      </x>
  );
}

export default App;
